<template>
  <div id="signin">
    <div class="signin-form">

    </div>
  </div>
</template>

<script>
  import { getSessionExpiredRedirectBase } from '@/utils/contextRedirect'

  export default {
    created() {
      window.location.href = getSessionExpiredRedirectBase();
    },
  }
</script>
